export enum BonusesTabsEnum {
  DAILY_REWARD = 'Daily Reward',
  DAILY_TASK = 'Daily Task',
  SPIN_BANNER = 'Spin Banner',
}
